import { oldMEAInstance as instance } from '@common/libs/meaAxios/index.js';
import * as constant from '@services/Constants';

import tokenUtil from './tokenUtil.js';

export const getBaseUrl = () => {
  const host = constant.MEA_SERVER_CONFIGURATION.port
    ? `${constant.MEA_SERVER_CONFIGURATION.host}:${constant.MEA_SERVER_CONFIGURATION.port}`
    : `${constant.MEA_SERVER_CONFIGURATION.host}`;
  return `${constant.MEA_SERVER_CONFIGURATION.protocol}://${host}${constant.MEA_SERVER_CONFIGURATION.apiPath}`;
};

export const getBaseTEMUrl = () => import.meta.env.VITE_TEM_API_URL;

export const getGoogleMapsBaseUrl = () => import.meta.env.VITE_GOOGLE_MAPS_BASE_URL;

export const getBaseHeaders = (auth = true) => {
  const temp = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Credentials': 'true'
  };
  return auth
    ? {
        ...temp,
        Authorization:
          'Basic ' + btoa(`${constant.CREDENTIALS.user}:${constant.CREDENTIALS.password}`)
      }
    : temp;
};

export const getFormHeaders = () => {
  const auth = 'Basic ' + btoa(`${constant.CREDENTIALS.user}:${constant.CREDENTIALS.password}`);
  return {
    Authorization: auth,
    'Access-Control-Allow-Credentials': 'true',
    'Content-Type': 'multipart/form-data'
  };
};

instance.interceptors.request.use(
  (config) => {
    const token = tokenUtil.getLocalAccessToken();
    if (token) {
      config.headers['x-access-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    const originalConfig = res.config;
    if (originalConfig.url.includes(constant.MEA_SERVER_CONFIGURATION.resource.login)) {
      // user is logged in successfully
      tokenUtil.setUser(res.data);
    }
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (
      !originalConfig.url.includes(constant.MEA_SERVER_CONFIGURATION.resource.login) &&
      err.response
    ) {
      // Access token was expired
      if (err.response.status === 403 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const urlPart = getBaseUrl() + constant.MEA_SERVER_CONFIGURATION.resource.refreshToken;

          const response = await instance.post(urlPart, {
            refreshToken: tokenUtil.getLocalRefreshToken()
          });

          const { accessToken } = response.data;
          tokenUtil.updateLocalAccessToken(accessToken);

          return instance(originalConfig);
        } catch (error) {
          // Session expired; log out user
          if (
            error?.response?.data?.code === 'sessionExpired' ||
            error?.response?.data?.code === 'sessionTokenMissing' ||
            error?.message === 'sessionCorrupted'
          ) {
            tokenUtil.removeUser();
          }
          return Promise.reject(error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default instance;
